import { ExportColumn } from '../types';
import { resolveSelectedColumnNames } from './resolveSelectedColumnNames';

// A formatItem column formats from a per-row value, so display formatting needs that item fetched too.
export const resolveExportRequestItemNames = (
  columns: ExportColumn[]
): string[] => {
  const itemNames = resolveSelectedColumnNames(columns);

  columns.forEach((column) => {
    const { formatItem } = column.formatConfig;

    if (column.selected && formatItem && !itemNames.includes(formatItem)) {
      itemNames.push(formatItem);
    }
  });

  return itemNames;
};
